// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-environment-banner-___environment-banner__section___fvfaH {
  color: var(--gray-darker);
  background-color: var(--warning-bg);
  padding: var(--container-padding);
}

.src-components-environment-banner-___environment-banner__title___EQlvs {
  display: inline-block;
  margin: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/environment-banner/environment-banner.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".section {\n  color: var(--gray-darker);\n  background-color: var(--warning-bg);\n  padding: var(--container-padding);\n}\n\n.title {\n  display: inline-block;\n  margin: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `src-components-environment-banner-___environment-banner__section___fvfaH`,
	"title": `src-components-environment-banner-___environment-banner__title___EQlvs`
};
export default ___CSS_LOADER_EXPORT___;
